import { render, staticRenderFns } from "./InventoryRunComponent.vue?vue&type=template&id=5bff6485&scoped=true&"
import script from "./InventoryRunComponent.vue?vue&type=script&lang=js&"
export * from "./InventoryRunComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bff6485",
  null
  
)

export default component.exports